import { render, staticRenderFns } from "./AddMember.vue?vue&type=template&id=b51b00b8&scoped=true&lang=pug&"
import script from "./AddMember.vue?vue&type=script&lang=js&"
export * from "./AddMember.vue?vue&type=script&lang=js&"
import style0 from "./AddMember.vue?vue&type=style&index=0&id=b51b00b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51b00b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/Kou/projects/vue-projects/joseph/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {VIcon})
